/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ({

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

( function () {

    tinymce.PluginManager.add( 'appointments_shortcodes', function ( editor ) {

        var datepickers = [];

        /**
         * Generate the content for a shortcode popup
         *
         * @param shortcode
         * @returns {{text: *, onclick: onclick}}
         */
        function appointments_shortcode_item( shortcode ) {
            var body = [],
                field;

            for ( var i in shortcode.defaults ) {
                field = appointments_shortcode_field( i, shortcode.defaults[i] );
                if ( field ) {
                    body.push( field );
                }
            }

            return {
                text: shortcode.name,
                onclick: function () {
                    editor.windowManager.open({
                        title: shortcode.name,
                        body: body,
                        onsubmit: appointments_shortcode_on_submit( shortcode )
                    });
                }
            };
        }

        /**
         * Generates a single field for Editor popup
         *
         * @param id
         * @param definition
         * @returns {boolean}
         */
        function appointments_shortcode_field( id, definition ) {
            var field = {};
            switch ( definition.type ) {
                case 'text': {
                    field = {
                        type: 'textbox',
                        name: id,
                        label: definition.name,
                        value: definition.value
                    };
                    break;
                }
                case 'datepicker': {
                    field = {
                        type: 'textbox',
                        name: id,
                        label: definition.name,
                        value: definition.value,
                        onclick: function() {
                            var id = this._id;
                            var element = jQuery( '#' + id );
                            if ( datepickers.indexOf( id ) < 0 ) {
                                // Initialize Datepicker
                                datepickers.push( id );
                                if ( ! element.length || typeof element.datepicker === 'undefined' ) {
                                    return;
                                }

                                element.datepicker();
                                element.datepicker( "option", "dateFormat", 'yy-mm-dd' );
                                element.datepicker( "option", "firstDay", AppointmentsDateSettings.weekStart );
                            }

                            if ( typeof element.datepicker === 'function' ) {
                                element.datepicker( 'show' );
                            }

                        }
                    };
                    break;
                }
                case 'select': {
                    field = {
                        type: 'listbox',
                        name: id,
                        label: definition.name,
                        values: definition.options
                    };
                    break;
                }
                case 'checkbox': {
                    field = {
                        type: 'checkbox',
                        name: id,
                        label: definition.name,
                        value: 1
                    };

                    if ( definition.value ) {
                        field.checked = true;
                    }
                    break;
                }
            }

            if ( definition.help ) {
                field.tooltip = definition.help
            }

            return field;
        }

        /**
         * Generates the onSubmit action for a group of fields
         *
         * @param shortcode
         * @returns {Function}
         */
        function appointments_shortcode_on_submit( shortcode ) {
            return function( e ) {
                var atts = '';
                var value;
                for ( var i in shortcode.defaults ) {
                    if ( typeof e.data[ i ] !== 'undefined' && shortcode.defaults[i].value != e.data[i] ) {
                        value = e.data[i];
                        if ( 'checkbox' === shortcode.defaults[i].type ) {
                            value = value ? 1 : 0;
                        }
                        atts += ' ' + i + '="' + value + '"';
                    }
                }
                editor.insertContent( '[' + shortcode.shortcode + atts + ']' );
            }
        }

        var ed = tinymce.activeEditor,
            shortcode,
            registeredShortcodes;

        var app_menu = [];



        registeredShortcodes = ed.getLang( 'appointments_shortcodes.shortcodes' );

        for ( var i in registeredShortcodes ) {
            shortcode = registeredShortcodes[i];

            app_menu.push((function (short) {
                return appointments_shortcode_item(short);
            })(shortcode));
        }



        editor.addButton( 'appointments_shortcodes', {
            text: ed.getLang( 'appointments_shortcodes.label' ),
            type: 'menubutton',
            menu: app_menu
        });
    });
})();

/***/ })

/******/ });


// WEBPACK FOOTER //
// editor-shortcodes.js